import { TRootState } from '../storeTypes';
export const getBurgerState = (state: TRootState) => state.burger;
